export enum ViewType {
	PROFILE = 'profile',
	JOURNEY = 'journey',
}
